import { render } from "./LungSpecificSectionDetails.vue?vue&type=template&id=81c5ca7e&scoped=true"
import script from "./LungSpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./LungSpecificSectionDetails.vue?vue&type=script&lang=js"

import "./LungSpecificSectionDetails.vue?vue&type=style&index=0&id=81c5ca7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c5ca7e"],['__file',"src/components/LungSpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81c5ca7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81c5ca7e', __exports__)) {
    api.reload('81c5ca7e', __exports__)
  }
  
  module.hot.accept("./LungSpecificSectionDetails.vue?vue&type=template&id=81c5ca7e&scoped=true", () => {
    api.rerender('81c5ca7e', render)
  })

}


export default __exports__